import $ from 'jquery';
import objectFitImages from 'object-fit-images';

// Generate a random number between 0 and 255
export const randRGB = () => Math.round(Math.random() * 255);

/**
 * transformSuperscript
 *
 * Wraps superscript text with <sup></sup> tags
 *
 * @returns {bool}
 */
export const transformSuperscript = () => {
  document.body.innerHTML = document.body.innerHTML.replace(
    /[™®]/g,
    '<sup>$&</sup>'
  );
};

/**
 * Smooth scroll to targets of anchor links
 *
 * @param {string} target - Anchor element's href value
 */
export const smoothAnchorScroll = target => {
  const $targetEl = $(target);
  $('html, body').animate(
    {
      scrollTop: $targetEl.offset().top - 50,
    },
    500,
    () => {
      // Set focus on target element for accessibility
      $targetEl.focus();
    }
  );
};

/**
 * isIE()
 *
 * Checks if browser is ie.
 *
 * @returns {bool}
 */
export const isIE = () => {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  const trident = ua.indexOf('Trident/');

  if (msie > 0 || trident > 0) {
    // IE or edge => return true
    return true;
  }
  // other browser
  return false;
};

/**
 * objectFitFallback()
 *
 * Adds an IE fallback for `object-fit: cover` style attributes.
 *
 * https://www.npmjs.com/package/object-fit-images
 */
export const objectFitFallback = () => {
  const fallbackImages = $('.object-fit-cover').find('img');
  fallbackImages.each((i, el) => {
    // object-fit-images() is triggered on images with this font-family.
    $(el).css('font-family', '"object-fit: cover;"');
  });
  objectFitImages(fallbackImages);
};

export default {};
